module.exports = __webpack_public_path__ + "static/media/dbc.313f5f9d.png";